import React from "react";
import SignIn from "../components/Auth/SignInSide";

const Login = (props) => {
  if (props.authState !== "signIn") {
    return null;
  }

  return <SignIn {...props} />;
};

export default Login;
